// removed by extract-text-webpack-plugin
module.exports = {"toggle":"toggle_3sLH2","circle":"circle_1Smbi","instructions":"instructions_uUAza","inspiration":"inspiration_3qCb2","image":"image_1PXOr","text":"text_1nh8h","closed":"closed_d5Naj"};


//////////////////
// WEBPACK FOOTER
// ./app/components/assignment-instructions/styles.scss
// module id = 407
// module chunks = 1